<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <material-card icon="mdi-clipboard-text" inline title="Module Access">
            <v-card flat class="px-2">
              <form autocomplete="off" @submit.prevent="onSubmit">
                <v-row>
                  <v-col cols="12" md="6">
                    <label class="font-weight-medium body-2">Module Name</label>
                    <v-text-field placeholder="name" class="my-0 py-1" v-model.trim="name"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <label class="font-weight-medium body-2">isAuth</label>
                    <v-switch v-model="isAuth" :label="isAuth ? 'true' : 'false'" color="primary"></v-switch>
                  </v-col>
                  <v-col cols="12">
                    <label class="font-weight-medium body-2">Sub-Module</label>
                    <v-card-component>
                      <b-table bordered :data="inputDataArray">
                        <template slot-scope="data">
                          <b-table-column label="Name" width="150">
                            <input class="input" type="text" v-model.trim="inputDataArray[data.index]" />
                          </b-table-column>

                          <b-table-column label="Action" custom-key="actions" class="is-actions-cell" width="200" centered>
                            <div class="buttons">
                              <button class="button is-small is-danger" type="button" title="Delete" @click="removeData(data.index)" v-if="inputDataArray.length > 1">
                                <b-icon icon="delete" size="is-small"></b-icon>
                              </button>
                              &nbsp;&nbsp;&nbsp;
                              <button class="button is-small is-primary" type="button" title="Add new" @click="addNewJson(data.index, data.row)" v-if="inputDataArray.length === data.index + 1">
                                <b-icon icon="plus" size="is-small"></b-icon>
                              </button>
                            </div>
                          </b-table-column>
                        </template>
                      </b-table>
                      <footer class="column has-text-right">
                        <button class="button is-success" type="submit">Save</button>
                      </footer>
                    </v-card-component>
                  </v-col>
                </v-row>
              </form>
            </v-card>
          </material-card>
        </v-col>
        <v-col cols="12">
          <material-card icon="mdi-clipboard-text" inline title="Manage System End Point Access for this Role">
            <v-card-text class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
              <v-text-field
                :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
                v-model="search"
                append-icon="mdi-magnify"
                class="ml-auto mb-2"
                label="Search"
                hide-details
                single-line
                style="max-width:350px;"
              />
            </v-card-text>

            <v-divider class=" my-0 " />
            <v-data-table
              :footer-props="{
                'items-per-page-options': [5, 10, 20, 40]
              }"
              :items-per-page="20"
              :headers="headers2"
              :items="allSystemEndPoints"
              :search.sync="search"
            >
              <template v-slot:item.isActive="{ item }">
                <v-checkbox class="pa-0 pt-2 ma-0 mt-2" v-model="item.isActive"></v-checkbox>
              </template>
              <!-- <template v-slot:item.isActiveInActive="{ item }">
                <span v-text="item.isActive ? 'Active' : 'Deactive'"></span>
              </template> -->
              <template v-slot:item.method="{ item }">
                <div :class="getColor(item.method)">
                  {{ item.method }}
                </div>
              </template>

              <template v-slot:item.subModule="{ item }">
                <multiselect
                  class="overflowmultiselect2"
                  required
                  label="name"
                  track-by="name"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="false"
                  :preselect-first="false"
                  :multiple="true"
                  :options="subdashboardData"
                  v-model="item.subDashboardEndPointMaps"
                  ><template slot="tags" slot-scope="{ values }"
                    ><span class="multiselect__single" v-if="values.length">
                      {{ values.name }}
                    </span></template
                  >
                </multiselect>
              </template>
              <template v-slot:item.isWrite="{ item }">
                <v-checkbox class="pa-0 pt-2 ma-0 mt-2" v-model="item.isWrite"></v-checkbox>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn @click="saveAccess(item.isActive, item.isWrite, item.subDashboardEndPointMaps, item.id)" class="px-2 ml-1 ma-1" color="primary" min-width="0" small>
                  <v-icon small>mdi-content-save</v-icon>
                </v-btn>
              </template>
              <template v-slot:no-data>
                <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
              </template>
            </v-data-table>
          </material-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import MaterialCard from '@/components/template/MaterialCard'
import VCardComponent from '@/components/template/VCardComponent'
import constants from '@/utils/constants'
import Multiselect from 'vue-multiselect'
import _ from 'lodash'

// import store from '../../store'

export default {
  components: {
    Multiselect,
    MaterialCard,
    VCardComponent
  },
  props: ['uniqueId'],
  data () {
    return {
      isWrite: false,
      isActive: false,
      isDefault: false,
      subdashboardID: [],
      inputDataArray: ['DEFAULT'],
      loadingComponent: null,
      loc: false,
      pathName: [],
      isAuth: true,
      name: '',
      toEditRoleFlag: true,
      allSystemEndPoints: [],
      subdashboardData: [],
      isLoading: false,
      search: '',
      // headers: [
      //   { text: 'Name', value: 'name', sortable: true },
      //   { text: 'Action', value: 'actions', align: 'center', sortable: false }
      // ],
      headers2: [
        { text: 'S No.', value: 'sno', sortable: false },
        { text: 'is Active', value: 'isActive', align: 'center', sortable: true },
        { text: 'Active/Deactive', value: 'isActiveInactive', align: 'center', sortable: true },
        { text: 'End Point', value: 'name', sortable: true },
        { text: 'Method', value: 'method', sortable: true },
        { text: 'Description', value: 'description', sortable: true },
        { text: 'Sub-module', value: 'subModule', sortable: false },
        { text: 'isWrite', value: 'isWrite', sortable: true },
        { text: 'Action', value: 'actions', align: 'center', sortable: false }
      ],
      tags: {
        GET: 'has-text-primary',
        PUT: 'has-text-link',
        POST: 'has-text-success',
        DELETE: 'has-text-danger'
      }
    }
  },

  async created () {
    await this.onStart()
  },
  methods: {
    getColor (method) {
      if (method === 'DELETE') return 'v-accent font-weight-bold'
      else if (method === 'POST') return 'v-pink font-weight-bold'
      else if (method === 'PUT') return 'v-warning font-weight-bold'
      else return 'v-green font-weight-bold'
    },
    onStart: async function () {
      if (this.uniqueId) {
        try {
          this.isLoading = true
          const dataResponse = await http.get(`${constants.API_URL}/api/dashboard-module/${this.uniqueId}`)
          const endpointData = await http.get(`${constants.API_URL}/api/dashboard-module/system-end-points/${this.uniqueId}`)

          this.allSystemEndPoints = endpointData.data
          this.allSystemEndPoints.forEach((e, i) => {
            e.sno = i + 1
            e.isActiveInactive = e.isActive ? 'Active' : 'Deactive'
          })
          this.subdashboardData = dataResponse.data.subDashboards

          this.name = dataResponse.data.name
          this.isAuth = dataResponse.data.isAuth

          let sub = []

          _.map(endpointData.data, obj => {
            sub = []
            _.map(obj.subDashboardEndPointMaps, item => {
              _.map(dataResponse.data.subDashboards, item1 => {
                if (item1.id === item.subDashboardID) {
                  sub.push({ name: item1.name, id: item.subDashboardID })
                  obj.subDashboardEndPointMaps = sub
                  obj.subDashboardEndPointMaps = _.uniqBy(obj.subDashboardEndPointMaps, 'id')
                }
              })
            })
          })

          if (!_.isEmpty(dataResponse.data.subDashboards)) {
            this.inputDataArray = dataResponse.data.subDashboards.filter(obj => {
              if (obj.isActive) {
                return obj
              }
            })
            this.inputDataArray = _.map(this.inputDataArray, 'name')
          }
        } catch (e) {
          const errorMessage = (e && e.response && e.response.data.message) || e.message
          console.log('Error While Saving Module', errorMessage)
          this.lock = false

          return this.$dialog.error({
            text: errorMessage,
            title: 'Error'
          })
        } finally {
          this.isLoading = false
        }
      }
    },
    removeData: function (index) {
      this.inputDataArray.splice(index, 1)
    },
    addNewJson: function (index, value) {
      this.inputDataArray.push('')
    },

    async onSubmit () {
      let trimArray = []
      this.inputDataArray.forEach(item => {
        if (item) {
          trimArray.push(item)
        }
      })
      const formData = {
        name: this.name,
        isAuth: this.isAuth,
        module: trimArray
      }

      try {
        this.isLoading = true

        if (this.uniqueId) {
          await http.put(`${constants.API_URL}/api/dashboard-module/${this.uniqueId}`, formData)

          return this.$dialog.info({
            title: 'Success',
            text: 'Module updated successfully!'
          })
        } else {
          await http.post(`${constants.API_URL}/api/dashboard-module`, formData)
          this.loader = false
          return this.$dialog.info({
            title: 'Success',
            text: 'Data Saved successfully!'
          })
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While Saving Module', errorMessage)
        this.lock = false
        this.hasClicked = false
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
        await this.onStart()
      }
    },
    saveAccess: async function (active, write, subDashboardEndPointMaps, endPointID) {
      try {
        const payLoad = {
          isActive: active || false,
          dashboardID: this.uniqueId,
          endPointId: endPointID,

          isWrite: write || false
        }
        if (subDashboardEndPointMaps) {
          payLoad.subDashboardID = _.map(subDashboardEndPointMaps, 'id')
        }

        await http.post(`${constants.API_URL}/api/dashboard-module/allow-access`, payLoad)
        await this.onStart()
        this.loader = false

        return this.$dialog.info({
          title: 'Success',
          text: 'Module Access Saved successfully!'
        })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While Saving Module', errorMessage)
        this.lock = false
        this.hasClicked = false
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
